import { MenuItemsType, DropdownMenuItemType } from '@tianguis-finance/uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    showItemsOnMobile: true,
    hideSubNav: true,
    items: [
      {
        label: t('Tianguis Swap'),
        href: '/swap',
      },
      {
        label: t('Tianguis Liquidity'),
        href: '/liquidity',
      },
      {
        label: t('Pancake Swap'),
        href: 'https://pancakeswap.finance/swap',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    icon: 'Earn',
    showItemsOnMobile: true,
    hideSubNav: true,
    items: [
      {
        label: t('Puestos'),
        href: '/farms',
      },
      {
        label: t('Tanda'),
        href: '/pools',
      },
      {
        label: t('La Bodega(no activo)'),
        href: 'https://bodega.tianguis.finance',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: t('Tienda'),
    icon: 'Ifo',
    href: 'https://criptotianguis.mx/',
    showItemsOnMobile: true,
    hideSubNav: true,
    items: [
      {
        label: t('CriptoTianguis.MX'),
        href: 'https://criptotianguis.mx/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: 'Mas...',
    href: '',
    icon: 'Info',
    hideSubNav: true,
    items: [
      {
        label: t('Info'),
        href: '/info',
      },
      {
        label: t('Documentation'),
        href: 'https://docs.tianguis.finance',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
]

export default config
